/* eslint-disable no-empty-function */
/* eslint-disable class-methods-use-this */
import { SourceTypeConfigHelper } from '../../create-pipeline/components/source-settings-form/config-helper';

export class ZendeskConfigHelper implements SourceTypeConfigHelper {
  constructor(public sourceTypeIdentifier: string) { }

  /**
   * Transform raw data from API to form data
   */
  getConfigFromRawData(rawData: any) {
    return {
      subDomain: rawData.sub_domain,
      oauthTokenId: rawData.oauth_token_id
    };
  }

  /**
   * Get default config from metadata
   */
  getDefaultConfig(metaData: any) {
    return {
      subDomain: '',
      oauthTokenId: null
    };
  }

  /**
   * Build connection params for API request
   */
  buildConnectionParams(data: any) {
    return {
      sub_domain: data.subDomain,
      oauth_token_id: data.oauthTokenId
    };
  }

  /**
   * Resolve metadata - called after OAuth to fetch additional data
   */
  metaDataResolver(sourceType: string, authData: any, rawData: any) {
    // For Zendesk, we don't need additional metadata resolution
    // The OAuth token ID is sufficient
    return Promise.resolve({});
  }
}
